import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentEditorRoutingModule } from './content-editor-routing.module';
import { ContentEditorComponent } from './content-editor.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { NgbDropdownModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxEditorModule } from 'ngx-editor';
import { SharedModule } from '../shared/shared.module';
import { CompetitorsOutlineComponent } from './competitors-outline/competitors-outline.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxLoadingModule } from 'ngx-loading';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QuillModule } from 'ngx-quill';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { CustomGaugeComponent } from '../shared/custom-gauge/custom-gauge.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { BulkContentEditorComponent } from './bulk-content-editor/bulk-content-editor.component';
import { MatListModule } from '@angular/material/list';
import { CustomUrlComponent } from './custom-url/custom-url.component';

const config: SocketIoConfig = {
	url: "https://socket.strell.io", // socket server url;
	options: {
		transports: ['websocket']
	}
}
@NgModule({
  declarations: [
    ContentEditorComponent,
    DashboardComponent,
    TextEditorComponent,
    CompetitorsOutlineComponent,
    BulkContentEditorComponent,
    CustomUrlComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ContentEditorRoutingModule,
    MatExpansionModule,
    MatIconModule,
    MatProgressBarModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    NgbPopoverModule,
    MatTabsModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDropdownModule,
    NgxEditorModule,
    ClipboardModule,
    NgCircleProgressModule.forRoot(),
    QuillModule.forRoot(),
    SharedModule,
    NgxLoadingModule.forRoot({}),
    MatSlideToggleModule,
    DragDropModule,
    NgbDropdownModule,
    MatButtonModule,
    MatInputModule,
    MatSnackBarModule,
    SocketIoModule.forRoot(config), 
    MatListModule
  ]
})
export class ContentEditorModule { }
